import { AdAccountType } from 'src/components/adminAccount/useLoadAccount';
import { create } from 'zustand';

interface AdAccountState{
    data : AdAccountType[],
    page : number;
    totalpage : number;
    pageSize : number
    status: string
    totalCount : number
    approveCount : number
    pendingCount : number
    inactiveCount : number
    setField : (field: keyof AdAccountState, value: any) => void 
    reset : ()=>void
}

const defaultValue = {
    data : [],
    totalpage: 0,
    page : 1,
    pageSize:8,
    status: 'all',
    totalCount : 0,
    approveCount : 0,
    pendingCount : 0,
    inactiveCount : 0,
}

export const useAdAccountStore = create<AdAccountState>((set)=>({
    ...defaultValue,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset : ()=>{
        set({...defaultValue})
    }
}))